<template>
  <div style="display: flex; flex-direction: column">
    <div class="btn">
      <el-button
        v-if="addState"
        type="primary"
        @click="_modify(null)"
      >新增</el-button>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        style="height: 100%"
      >
        <el-table-column prop="fName" label="角色名称" />
        <!-- <el-table-column prop="fScale" label="小数位">
      </el-table-column> -->
        <el-table-column prop="fDes" label="角色介绍" />
        <el-table-column prop="fCreater" label="创建人" />
        <el-table-column
          prop="fCreateTime"
          label="创建时间"
          :formatter="dateFormat"
        />
        <el-table-column prop="fModify" label="最后修改人" />
        <el-table-column
          prop="fModifyTime"
          label="最后修改时间"
          :formatter="dateFormat"
        />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button
                type="text"
                size="small"
                @click="_modify(scope.row)"
              >查看</el-button>
            </template>
            <template>
              <ConfirmButton
                v-if="delState"
                @confirm="_delete(scope.row)"
              >删除</ConfirmButton>
            </template>
            <template>
              <el-button
                v-if="authorityState"
                type="text"
                size="small"
                @click="_permission(scope.row)"
              >权限设置</el-button>
            </template>
            <template>
              <el-button
                v-if="roleState"
                type="text"
                size="small"
                @click="_viewUser(scope.row)"
              >用户列表</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import roleInfoForm from './roleInfoForm'
import permission from './permission'
import userList from './userList'
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    roleInfoForm,
    ConfirmButton,
    permission,
    userList
  },
  data() {
    return {
      tableData: [],
      loading: false,
      currentEditItem: null,

      addState: true,
      editState: true,
      delState: true,
      authorityState: true,
      roleState: true
    }
  },
  mounted() {
    this.refresh()
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants, "userGrants");
    userGrants.forEach((val) => {
      if (val.key == '001002002') {
        this.addState = val.isGrant
      }
      if (val.key == '001002003') {
        this.editState = val.isGrant
      }
      if (val.key == '001002004') {
        this.delState = val.isGrant
      }
      if (val.key == '001002005') {
        this.authorityState = val.isGrant
      }
      if (val.key == '001002006') {
        this.roleState = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('SystemApplication/Role/RoleEntry', {})
        .then((res) => {
          // console.log(res, 'res')
          this.tableData = res.datalist
        })
        .finally(() => (this.loading = false))
    },
    _modify: async function(row) {
      // console.log(row, 'row')
      const isNew = !row
      if (isNew) {
        this.currentEditItem = {
          fRoleID: null,
          fName: '',
          fDes: '',
          fModifyTimestamp: 0
        }
      } else {
        this.currentEditItem = await this.$httpPost(
          'SystemApplication/Role/GetRole',
          { fid: row.fRoleID }
        ).then((res) => res.datalist)
        this.currentEditItem['fCreateTime'] = moment(
          this.currentEditItem['fCreateTime']
        ).format('YYYY-MM-DD HH:mm:ss')
        this.currentEditItem['fModifyTime'] = moment(
          this.currentEditItem['fModifyTime']
        ).format('YYYY-MM-DD HH:mm:ss')
        if (this.currentEditItem['fCreateTime'] == 'Invalid date') {
          this.currentEditItem['fCreateTime'] = ''
        }
        if (this.currentEditItem['fModifyTime'] == 'Invalid date') {
          this.currentEditItem['fModifyTime'] = ''
        }
      }
      let or
      if (isNew) {
        or = this.addState
      } else {
        or = this.editState
      }
      const h = this.$createElement
      this.$formDlg({
        title: `${isNew ? '新增角色' : '查看角色'}`,
        width: '30%',
        formTpl: <roleInfoForm form={this.currentEditItem}></roleInfoForm>,
        formSubmit: (formData) => this.postData(isNew ? 0 : 1, formData),
        readonly: !or
      })
    },

    _delete(row) {
      this.postData(2, row)
    },
    //    查看权限设置
    _permission(row) {
      // console.log(row, "row");
      this.$httpPost('SystemApplication/Role/RoleGrant', { fid: row.fRoleID })
        .then((res) => {
          // console.log(res);
          this.$formDlg({
            title: '查看权限',
            width: '30%',
            formTpl: <permission treeData={res.datalist}></permission>,
            formSubmit: (treeData) => this.postPermission(treeData)
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 查看用户
    _viewUser(row) {
      // console.log(row)
      this.$formDlg({
        title: '用户列表',
        width: '30%',
        formTpl: <userList fRoleID={row.fRoleID}></userList>,
        readonly: true
        // formSubmit: (treeData) => this.postPermission(treeData)
      })
    },
    // 修改角色
    postData(modifyType, data) {
      return this.$httpPost('SystemApplication/Role/RoleModify', {
        datalist: JSON.stringify({
          modifyType: modifyType,
          info: data
        })
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    // 更改权限
    postPermission(treeData) {
      // console.log(treeData, 'treeData1')
      return this.$httpPost('SystemApplication/Role/RoleGrantModify', {
        datalist: JSON.stringify({ ...treeData })
      }).then((res) => {
        // console.log(res, 'terrRes')
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
